<template>
  <div class="tab-pane fade active" id="stay-average-by-date" role="tabpanel" aria-labelledby="stay-average-by-date-tab">
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-4">
          <label for="inputEmail4" class="form-label">風景區</label>
          <select class="form-control" v-model.number="selectScenicAreaId">
            <option value="-1">全部</option>
            <option v-for="(list, index) in carFlowScenicArea" :key="index" :value="list.id">{{ list.name }}</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime input-class="form-control" type="date" format="yyyy-MM-dd" :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1" :max-datetime="maxSelectTime" :auto="true" v-model="startTime">
          </datetime>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime input-class="form-control" type="date" format="yyyy-MM-dd" :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1" :max-datetime="maxSelectTime" :auto="true" v-model="endTime">
          </datetime>
        </div>

        <div class="col-md-ˊ d-flex align-items-end">
          <button type="button" class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1" @click="queryData"
            :disabled="isWaitCCTVList">
            <i class="fas fa-search"></i> 查詢
          </button>
          <button type="button" class="btn btn-primary btn-sm rounded-pill px-3 mx-1" @click="queryCSV"
            :disabled="isWaitCCTVList">
            <i class="fas fa-share"></i> 匯出
          </button>
        </div>
      </form>

      <h1 style="margin-top: 0px;">遊客停留時間（天）</h1>

      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2">
        <div class="col">
          <div class="card card-clean h-100">
            <div class="bd-example">

              <table id="stayAverageByDate" class=" w3-table-all table table-hover table-striped">
                <thead class="table-dark ">
                  <tr>
                    <th scope="col" width="5%">#</th>
                    <th scope="col">風景區</th>
                    <th scope="col">日期</th>
                    <th scope="col">{{getVehicleTypeName('bus')}}(分鐘)/總數</th>
                    <th scope="col">{{getVehicleTypeName('smallbus')}}(分鐘)/總數</th>
                    <th scope="col">{{getVehicleTypeName('car')}}(分鐘)/總數</th>
                    <th scope="col">{{getVehicleTypeName('motorbike')}}(分鐘)/總數</th>
                    <th scope="col">{{getVehicleTypeName('truck')}}(分鐘)/總數</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, key) in stayAverageData" :key="key" :class="tableCenterStyle">
                    <td>{{ key + 1 }}</td>
                    <td>{{ item.areaName }}</td>
                    <td>{{ item.dateTime|dateFormat }}</td>
                    <td>{{ item.data.bus|timeFormat}}/{{ item.data.bus.count }}</td>
                    <td>{{ item.data.smallbus|timeFormat}}/{{ item.data.smallbus.count }}</td>
                    <td>{{ item.data.car|timeFormat}}/{{ item.data.car.count }}</td>
                    <td>{{ item.data.motorbike|timeFormat}}/{{ item.data.motorbike.count }}</td>
                    <td>{{ item.data.truck|timeFormat}}/{{ item.data.truck.count }}</td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from "moment";
import Utils from '../../utils/utils';
import CONST from '../../utils/const'
import exportCSV from '../../utils/exportCSV'
import {getStayAverageInterval} from '../../api/adminDist/stayAverageApi'
export default {
  name: "Home",
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      startTime: moment().startOf('day ').format(),
      endTime: moment().endOf('day').format(),
      selectScenicAreaId: -1,
      stayAverageData: [],
      isWaitCCTVList: false,
    };
  },
  computed: {
    maxSelectTime() {
      return moment()
        .startOf('m')
        .toISOString()
    },
    ...mapState('scenicArea', { scenicAreaList: 'allscenicArea' }),

    carFlowScenicArea() {
      return this.scenicAreaList.filter(s => (s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.CAR_FLOW))
    },
  },
  methods: {
    async queryCSV() {
      this.isWaitCCTVList = true
      const stayAverageData = await this.searchData()
      if (Utils.isEmptyObject(stayAverageData)) {
        return
      }
      let vm=this
      const selectedScenery = this.scenicAreaList.find(s => s.id === this.selectScenicAreaId)
      const scenicName = selectedScenery ? selectedScenery.name : '-'
      const csvContent = [[
        '風景區',
       '日期',
        `${this.getVehicleTypeName('bus')}(小時)/總數`,
        `${this.getVehicleTypeName('smallbus')}(小時)/總數`,
        `${this.getVehicleTypeName('car')}(小時)/總數`,
        `${this.getVehicleTypeName('motorbike')}(小時)/總數`,
        `${this.getVehicleTypeName('truck')}(小時)/總數`,
      ]]
      stayAverageData.forEach(item => {
        const row = []
        row.push(item.areaName)
        row.push(vm.$options.filters.dateFormat(item.dateTime))
        row.push(`${vm.$options.filters.timeFormat(item.data.bus)}/${item.data.bus.count}`)
        row.push(`${vm.$options.filters.timeFormat(item.data.smallbus)}/${item.data.smallbus.count}`)
        row.push(`${vm.$options.filters.timeFormat(item.data.car)}/${item.data.car.count}`)
        row.push(`${vm.$options.filters.timeFormat(item.data.motorbike)}/${item.data.motorbike.count}`)
        row.push(`${vm.$options.filters.timeFormat(item.data.truck)}/${item.data.truck.count}`)

        csvContent.push(row)
      })

      const fileName = `CSV_${moment(this.startTime).format('YYYY/MM/DD')}-${moment(this.endTime).format('YYYY/MM/DD')}_平均停留(天).csv`
      exportCSV.genCSVFile(csvContent, fileName)
      this.isWaitCCTVList = false
    },

    async queryData() {
      this.isWaitCCTVList = true
      this.stayAverageData = await this.searchData()
      this.updateTable()
      this.isWaitCCTVList = false
    },

    async searchData() {
      if (Utils.isEmptyObject(this.startTime) || Utils.isEmptyObject(this.endTime)) {
        alert('請選擇起訖時間')
        return
      }

      if (moment(this.endTime).diff(moment(this.startTime)) < 0) {
        alert('結束時間不可以小於開始時間')
        return
      }


      const scenicAreaList = []
      if(this.selectScenicAreaId !== -1) {
        scenicAreaList.push(this.selectScenicAreaId)
      }
      const condition = {
        sttime:moment(this.startTime).startOf('day').format(),
        endtime:moment(this.endTime).endOf('day').format(),
        interval:"day",
        areas: scenicAreaList
      }
      //await this.$store.dispatch('StayAverage/getStayAverageByDate', condition)
      //const stayAverageData = this.$store.getters['StayAverage/getStayAverageByDate']
      let stayAverageData=await getStayAverageInterval(condition);
      console.log(stayAverageData)
      return stayAverageData
    },

    initTable: function () {
      this.table = $("#stayAverageByDate").DataTable({
        aoColumns: [
          ...new Array($("#stayAverageByDate th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url :'/json/dataTableZHTW.json'
        },
        "pageLength": 25,
      });
    },

    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy()
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    },
    getVehicleTypeName(vehicleType){
      return CONST.ELK_CAR_TYPE[vehicleType];
    }
  },
  mounted() {
    this.updateTable()
  },
  filters:{
    timeFormat:function(object){
      let total=object.averageStayTime.totalMinutes;
      total=Math.round(total * 100) / 100;
      return total+'m';
    },
    dateFormat:function(dateTime){
      return moment(dateTime).format('YYYY-MM-DD');
    }
  }
};
</script>
<style>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
tbody > tr > td, tr > th{width:100%;white-space:normal;word-wrap:break-word;word-break:break-all;} /* td自動斷行 */
table{table-layout:fixed;word-break:break-all;}  /* table不超過div */
</style>